import {
    GET_SUBSCRIPTIONSTATUSES,
    GET_SUBSCRIPTIONPACKAGESS
} from '../../Actions/Admin/ManageSubscriptionStatusActions';

const initialState = {
	subscriptions: [],
};
export const reducer = (state = initialState, action) => {
	switch (action.type) {
        case GET_SUBSCRIPTIONSTATUSES:
            return {
                ...state,
                loading: true,
                subscriptionStatuses: action.payload
            };
        case GET_SUBSCRIPTIONPACKAGESS:
            return {
                ...state,
                loading: true,
                subscriptionPackages: action.payload
            };
        default:
            return state;
	}
};
